import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Grid, Container, Card, Button } from "semantic-ui-react";
import { ContextProvider } from "../../providers/app.provider";
import Guard from "../../components/guard";
// import { Redirect } from 'react-router-dom';

const HomePage = () => {
  useEffect(() => {
    indicatorDispatch({ type: "INDICATOR_SUBMIT", payload: "" });
  }, []);

  const {
    userDetails: { sfdcId, username, email, phone },
  } = useContext(ContextProvider);
  const { userDispatch, indicatorDispatch } = useContext(ContextProvider);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    userDispatch({
      type: "USER_DETAILS_UPDATE",
      payload: {
        name: name,
        value: value,
      },
    });
  };

  const clearForm = () => {
    userDispatch({ type: "USER_DETAILS_RESET" });
  };
  return (
    <Container
      style={{ paddingTop: "10px", paddingLeft: "20px", paddingRight: "20px" }}
    >
      <Grid columns={2} divided>
        <Grid.Row>
          <Grid.Column>
            <Form>
              <Form.Field inline required>
                <label>Salesforce Opportunity ID:</label>
                <input
                  placeholder="SFDC Opt ID"
                  value={sfdcId}
                  name="sfdcId"
                  onChange={handleChange}
                />
              </Form.Field>
              <Form.Field inline>
                <label style={{ paddingRight: "76px" }}>End Username:</label>
                <input
                  placeholder="End Username"
                  value={username}
                  name="username"
                  onChange={handleChange}
                />
              </Form.Field>
              <Form.Field inline>
                <label style={{ paddingRight: "76px" }}>Email Address:</label>
                <input
                  placeholder="Email Address"
                  value={email}
                  name="email"
                  onChange={handleChange}
                />
              </Form.Field>
              <Form.Field inline>
                <label style={{ paddingRight: "71px" }}>Phone Number:</label>
                <input
                  placeholder="Phone#"
                  value={phone}
                  name="phone"
                  onChange={handleChange}
                />
              </Form.Field>
            </Form>
            <Button
              onClick={clearForm}
              size="mini"
              compact
              style={{ marginLeft: "24%", marginTop: "10px" }}
            >
              Clear
            </Button>
          </Grid.Column>
          <Grid.Column>
            <Guard>
              <Card
                fluid
                style={{ height: "100px" }}
                as={Link}
                to="/new_customer"
                header="New Vormetric Customer"
                color="blue"
              />
              <Card
                fluid
                style={{ height: "100px" }}
                as={Link}
                to="/existing_customer"
                header="Existing Vormetric Customer"
                color="red"
              />
            </Guard>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default HomePage;
